import { render, staticRenderFns } from "./BudgetSimulation.vue?vue&type=template&id=552e8535&scoped=true&"
import script from "./BudgetSimulation.vue?vue&type=script&lang=js&"
export * from "./BudgetSimulation.vue?vue&type=script&lang=js&"
import style0 from "./BudgetSimulation.vue?vue&type=style&index=0&id=552e8535&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552e8535",
  null
  
)

export default component.exports